export const USER_ROLES = {
    OWNER: 'owner',
    ADMIN: 'admin',
    MEMBER: 'member',
} as const;

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];

export const OWNER_ONLY_ROLES: UserRole[] = [USER_ROLES.OWNER];

export const OWNER_AND_ADMIN_ROLES: UserRole[] = [USER_ROLES.OWNER, USER_ROLES.ADMIN];

export const ALL_TENANT_ROLES: UserRole[] = [USER_ROLES.OWNER, USER_ROLES.ADMIN, USER_ROLES.MEMBER];

export const ROUTE_ROLE_ACCESS = {
    aiAgent: OWNER_ONLY_ROLES,
    settings: OWNER_ONLY_ROLES,
    admin: OWNER_AND_ADMIN_ROLES,
    rules: OWNER_AND_ADMIN_ROLES,
    whatsappFlows: OWNER_AND_ADMIN_ROLES,
    knowledgeBase: ALL_TENANT_ROLES,
} as const;
